<template>
  <span class="rate-cell">
    <span class="rate-cell__track">
      <span
        class="rate-cell__fill"
        :style="{ width: `${percent}%` }"
      />
    </span>
    <span class="rate-cell__value">{{ value }}</span>
  </span>
</template>

<script>
export default {
  name: 'BaseRateCell',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    percent: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.rate-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &__track {
    width: 64px;
    height: 6px;
    border-radius: 3px;
    background: var(--ds-color-black-010);
    overflow: hidden;
  }

  &__fill {
    display: block;
    height: 100%;
    border-radius: 3px;
    background: var(--v-infoDarken-base);
  }

  &__value {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    font-size: 0.8rem;
  }
}
</style>
